<template>
  <div class="order-group">
    <Form :model="searchCondition" inline :label-width="60">
      <FormItem label="商品类型">
        <Select v-model="searchCondition.shop_type" class="com-width" clearable>
          <Option v-for="item in shopTypes" :value="item.key" :key="item.key">{{
            item.value
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="订单状态">
        <Select
          v-model="searchCondition.order_mix_status"
          class="com-width"
          clearable
        >
          <Option
            v-for="item in groupOrderStatuses"
            :value="item.key"
            :key="item.key"
            >{{ item.value }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="支付类型">
        <Select v-model="searchCondition.pay_type" class="com-width" clearable>
          <Option v-for="item in payTypes" :value="item.key" :key="item.key">{{
            item.value
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="下单时间">
        <Date-picker
          ref="datePicker"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          @on-change="onDateRange"
          style="width:280px;"
          :editable="false"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Date-picker>
      </FormItem>
      <FormItem label="商品名称">
        <Input
          v-model="searchCondition.shop_name"
          placeholder="请输入商品名称关键字"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="订单编号">
        <Input
          v-model="searchCondition.order_number"
          placeholder="请输入订单编号关键字"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="团编号">
        <Input
          v-model="searchCondition.group_number"
          placeholder="请输入团编号关键字"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入买家手机号"
          class="com-width"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onExport" class="btn-margin-right"
        >批量导出</Button
      >
      <Button type="primary" @click="onWatch" class="btn-margin-right"
        >查看报表</Button
      >
    </div>
    <div class="content">
      <mix-grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/order/index"
        :search="searchCondition"
        method="post"
        :rowsFormatter="onRowsFormatter"
      >
        <template slot-scope="{ row }" slot="buyer">
          <span>{{ row.nickname }}</span>
          <span
            v-if="row.uid && row.uid == row.open_group_uid"
            class="group-leader"
            >团长</span
          >
        </template>
        <template slot-scope="{ row }" slot="refundStatus">{{
          getRefundStatus(row)
        }}</template>
        <template slot-scope="{ row }" slot="action">
          <div class="table-btn-box">
            <Button type="text" size="small" @click="onDetail(row)"
              >订单详情</Button
            >
            <Button
              v-if="row.order_mix_status == 1"
              type="text"
              size="small"
              @click="onCancel(row)"
              >取消订单</Button
            >
            <Button
              v-if="row.group_id"
              type="text"
              size="small"
              @click="onCheckInGroupOrder(row)"
              >查看同团订单</Button
            >
            <Button
              v-if="row.order_mix_status == 1"
              type="text"
              size="small"
              @click="onChangePrice(row)"
              >改价</Button
            >
            <!-- <Button
              v-if="row.order_mix_status == 4"
              type="text"
              size="small"
              @click="onDelivery(row)"
              >发货</Button
            > -->
            <Button
              v-if="row.order_mix_status == 9"
              type="text"
              size="small"
              class="refunding"
              @click="onRefund(row)"
              >处理退款</Button
            >
          </div>
        </template>
      </mix-grid>
    </div>
    <exports-modal
      title="导出拼团订单"
      :type="3"
      :params="searchCondition"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></exports-modal>
    <delivery-dlg
      v-model="deliveryDlg.show"
      :data="deliveryDlg.data"
      @on-ok="onSearch(false)"
    ></delivery-dlg>
    <change-price-ex-dlg
      v-model="changePriceDlg.show"
      :order-id="changePriceDlg.orderId"
      :has-logistics="changePriceDlg.hasLogistics"
      @on-ok="onSearch(false)"
    ></change-price-ex-dlg>
    <refund-dlg
      v-model="refundDlg.show"
      :data="refundDlg.data"
      @on-ok="onSearch(false)"
    ></refund-dlg>
  </div>
</template>

<script>
import { PayType, GroupOrderStatus } from "@/utils/enums";
import ExportsModal from "@/components/ExportsModal";
import ChangePriceExDlg from "./components/ChangePriceExDlg";
import RefundDlg from "./components/RefundDlg";
import DeliveryDlg from "./components/DeliveryDlg";
export default {
  name: "order-group",
  components: {
    ExportsModal,
    ChangePriceExDlg,
    RefundDlg,
    DeliveryDlg
  },
  data() {
    return {
      searchCondition: {
        is_spell: 1,
        shop_type: "",
        order_mix_status: "",
        pay_type: "",
        created_start: "",
        created_end: "",
        shop_name: "",
        order_number: "",
        group_number: "",
        mobile: "",
        order_type: 7,
        group_id: ""
      },
      showExportModal: false,
      deliveryDlg: {
        show: false,
        data: {}
      },
      changePriceDlg: {
        show: false,
        orderId: 0,
        hasLogistics: true
      },
      refundDlg: {
        show: false,
        data: {}
      },
      shopTypes: [
        { key: 2, value: "大班课" },
        { key: 5, value: "点播课" },
        { key: 8, value: "音频课" },
        { key: 10, value: "图文课" },
        { key: 7, value: "面授课" },
        { key: 9, value: "系统课" },
        { key: 12, value: "图书" }
      ],
      groupOrderStatuses: GroupOrderStatus.getOptions(),
      payTypes: PayType.getOptions(),
      tableColumns: [
        {
          title: "订单编号",
          key: "order_number",
          mix: true
        },
        {
          title: "团编号",
          key: "group_bn",
          mix: true
        },
        {
          title: "下单时间",
          key: "created_at",
          mix: true
        },
        {
          title: "支付类型",
          key: "pay_type_name",
          mix: true
        },
        {
          title: "商品名称",
          key: "product_name",
          align: "center",
          minWidth: 300
        },
        {
          title: "单价(元) / 数量",
          key: "priceAndCount",
          align: "center",
          minWidth: 120
        },
        {
          title: "订单状态",
          key: "order_mix_status_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "退款维权",
          slot: "refundStatus",
          align: "center",
          minWidth: 100
        },
        {
          title: "买家",
          slot: "buyer",
          align: "center",
          minWidth: 100
        },
        {
          title: "买家手机号",
          key: "mobile",
          align: "center",
          minWidth: 120
        },
        {
          title: "实付金额",
          key: "order_price",
          align: "center",
          minWidth: 100
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100
        }
      ]
    };
  },
  created() {
    this.searchCondition.group_id = this.$route.query.group_id;
    this.searchCondition.is_spell = 1;
  },
  watch: {
    $route() {
      this.searchCondition.group_id = this.$route.query.group_id;
      this.searchCondition.is_spell = 1;
      this.onReset();
    }
  },
  methods: {
    // on event
    onDateRange(range) {
      this.searchCondition.created_start = range[0];
      this.searchCondition.created_end = range[1];
    },
    onSearch(reset = true) {
      this.searchCondition.is_spell = 1;
      this.$refs.grid.refresh(reset);
    },
    onReset() {
      this.$pub.clearObj(this.searchCondition, ["order_type", "group_id"]);
      this.$refs.datePicker.handleClear();
      this.onSearch();
    },
    onExport() {
      this.showExportModal = true;
    },
    onWatch() {
      this.$router.push({
        name: "Exports",
        query: {
          type: "order",
          order_type: 7
        }
      });
    },
    onDetail(row) {
      this.$router.push({
        name: "OrderGroupDetail",
        query: {
          order_id: row.order_id
        }
      });
    },
    async onCancel(row) {
      await this.$promiseConfirm("取消订单后，该订单将会被关闭，是否确认？");
      await this.$http.put("/api/spellGroup/order/cancel", {
        order_id: row.order_id
      });
      this.$Message.success("取消订单成功");
      this.onSearch(false);
    },
    onCheckInGroupOrder(row) {
      if (!row.group_id) return;
      this.$router.push({
        name: "OrderInGroup",
        query: {
          group_id: row.group_id
        }
      });
    },
    onChangePrice(row) {
      this.changePriceDlg.show = true;
      this.changePriceDlg.orderId = row.order_id;
      this.changePriceDlg.hasLogistics = row.shop_type == 12;
    },
    onDelivery(row) {
      this.deliveryDlg.show = true;
      this.deliveryDlg.data = row;
    },
    onRefund(row) {
      this.refundDlg.show = true;
      this.refundDlg.data = row;
    },
    onRowsFormatter(rows) {
      rows.forEach(i => {
        i.group_bn = i.group_bn || "--";
        i.order_mix_status_name = GroupOrderStatus.getValue(i.order_mix_status);
        i.pay_type_name = PayType.getValue(i.pay_type);
        i.priceAndCount = `${this.$pub.calcPrice(i.product_price)} * ${
          i.product_number
        }`;
        i.order_price = this.$pub.calcPrice(i.order_price);
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    },
    // other
    getRefundStatus(row) {
      if (row.refund_status == 3) {
        return "已驳回退款";
      }
      switch (row.order_mix_status) {
        case 6:
          return "已全额退款";
        case 7:
          return "卖家已同意退款";
        case 8:
          return "系统异常，退款失败";
        case 9:
          return "买家发起退款";
        default:
          return "--";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.order-group {
  .table-btn-box {
    display: flex;
    flex-direction: column;
  }
  .group-leader {
    background-color: #2d8cf0;
    white-space: nowrap;
    padding: 2px 4px;
    margin-left: 5px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
  }
  .refunding {
    color: red !important;
  }
}
</style>
